import { useEffect, useState } from "react";
import { toCanvas } from "bwip-js/browser";

// HUB-3 (HR uplatnica) 2D barcode — PDF417, ISO-8859-2 bytes.
const L2 = { "č": 0xe8, "ć": 0xe6, "š": 0xb9, "ž": 0xbe, "đ": 0xf0, "Č": 0xc8, "Ć": 0xc6, "Š": 0xa9, "Ž": 0xae, "Đ": 0xd0 };
const latin2 = (s) => Array.from(s || "").map((c) => (L2[c] ? String.fromCharCode(L2[c]) : c.charCodeAt(0) < 256 ? c : "?")).join("");
const cut = (s, n) => latin2(String(s || "").trim()).slice(0, n);

export function hub3Text({ amount, payer = {}, payee = {}, iban, model, reference, description }) {
  return [
    "HRVHUB30",
    "EUR",
    String(Math.round(Math.abs(Number(amount || 0)) * 100)).padStart(15, "0"),
    cut(payer.name, 30), cut(payer.address, 27), cut(payer.city, 27),
    cut(payee.name, 25), cut(payee.address, 25), cut(payee.city, 27),
    cut((iban || "").replace(/\s/g, ""), 21), cut(model || "HR99", 4), cut(reference, 22),
    "OTHR", cut(description, 35), "",
  ].join("\n");
}

function Hub3Barcode({ text }) {
  const [src, setSrc] = useState("");
  useEffect(() => {
    try {
      const c = document.createElement("canvas");
      toCanvas(c, { bcid: "pdf417", text, columns: 9, eclevel: 4, scale: 2, rowheight: 3, binarytext: true });
      setSrc(c.toDataURL("image/png"));
    } catch { setSrc(""); }
  }, [text]);
  return src ? <img src={src} alt="HUB-3 barkod" style={{ width: "58mm", height: "auto", marginTop: 6, imageRendering: "pixelated" }} data-testid="invoice-hub3-barcode" /> : null;
}

const Row = ({ l, v, tid }) => (
  <div style={{ marginBottom: 5 }} data-testid={tid}>
    <div style={{ fontSize: 8, letterSpacing: "0.04em", textTransform: "uppercase", color: "#64748b" }}>{l}</div>
    <div style={{ fontSize: 10.5, fontWeight: 600, color: "#0f172a", fontFamily: "monospace", wordBreak: "break-word", lineHeight: 1.35 }}>{v || "—"}</div>
  </div>
);

/** Bottom-right "Podaci za plaćanje" — only for unpaid invoices. */
export default function PaymentInfo({ inv }) {
  const s = inv.supplier || {};
  const issued = inv.status === "issued";
  const ref = inv.payment_reference;
  const payeeName = s.company_name || s.private_landlord_name || s.display_name;
  const text = hub3Text({
    amount: inv.total,
    payer: { name: inv.client_name, address: inv.client_address, city: [inv.client_postal_code, inv.client_city].filter(Boolean).join(" ") },
    payee: { name: payeeName, address: s.address, city: [s.postal_code, s.city].filter(Boolean).join(" ") },
    iban: s.iban, model: s.payment_model, reference: ref,
    description: `Racun ${inv.number || ""}`.trim(),
  });
  return (
    <div style={{ width: 290, border: "1px solid #cbd5e1", borderRadius: 4, padding: "10px 12px" }} data-testid="invoice-payment-info">
      <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: "#64748b", marginBottom: 6 }}>Podaci za plaćanje</div>
      <Row l="Primatelj" v={payeeName} />
      <Row l="IBAN" v={s.iban} tid="pay-iban" />
      <Row l="Model" v={s.payment_model || "HR99"} tid="pay-model" />
      <Row l="Poziv na broj" v={issued ? ref : "dodjeljuje se po zaključenju"} tid="pay-reference" />
      {issued && s.iban && <Hub3Barcode text={text} />}
    </div>
  );
}
